import { ShieldCheck, Network, Layers, Clock4, BookOpen, Handshake } from "lucide-react";

const BENEFITS = [
  {
    icon: ShieldCheck,
    title: "Estructuras que resisten",
    text: "Apego al marco legal, razón de negocio y soporte documental verificable.",
    image: "https://customer-assets.emergentagent.com/job_rp-profesional/artifacts/7vw75cb3_17anos.jpg",
  },
  {
    icon: Handshake,
    title: "Consejeros, no proveedores",
    text: "Confrontamos antes de que los problemas escalen.",
    image: "https://customer-assets.emergentagent.com/job_rp-profesional/artifacts/i105q47y_consejeros.jpg",
  },
  {
    icon: Network,
    title: "Presencia multi-ciudad",
    text: "Guadalajara y Ciudad de México (Torre Mayor).",
    image: "https://customer-assets.emergentagent.com/job_rp-profesional/artifacts/xrd9njo8_multiciudad.jpg",
  },
  {
    icon: BookOpen,
    title: "Credenciales que respaldan",
    text: "C.P., Maestría en Impuestos, AD1 IPADE, Consejero Certificado IMMPC, Comisión CAIGO del IMCP.",
    image: "https://customer-assets.emergentagent.com/job_rp-profesional/artifacts/k4rrs9nt_credenciales.jpg",
  },
  {
    icon: Layers,
    title: "Visión de largo plazo",
    text: "Planeación fiscal y patrimonial pensada para décadas, no para cierres mensuales.",
    image: "https://customer-assets.emergentagent.com/job_rp-profesional/artifacts/mw8pdhoi_estructuras-resisten.jpg",
  },
  {
    icon: Clock4,
    title: "17+ años continuos",
    text: "Práctica profesional ininterrumpida acompañando empresas familiares mexicanas.",
    image: "https://customer-assets.emergentagent.com/job_rp-profesional/artifacts/0lse9i2m_anoscontinuos.jpg",
  },
];

export default function Beneficios() {
  return (
    <section id="beneficios" data-testid="beneficios-section" className="py-20 sm:py-28 bg-white">
      <div className="rp-container">
        <div className="rp-reveal max-w-3xl">
          <span className="rp-kicker rp-kicker-green">Por qué elegirnos</span>
          <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-extrabold leading-tight" style={{ color: "var(--rp-ink)" }}>
            Una práctica que <span className="rp-gradient-text">resiste el tiempo</span> y la autoridad.
          </h2>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {BENEFITS.map((b, i) => {
            const Icon = b.icon;
            return (
              <article
                key={i}
                data-testid={`benefit-${i}`}
                className="group relative rp-reveal overflow-hidden rounded-2xl shadow-[0_10px_40px_-20px_rgba(60,57,80,0.25)] hover:shadow-[0_30px_70px_-25px_rgba(60,57,80,0.45)] transition-shadow duration-500 aspect-[4/5]"
                style={{ transitionDelay: `${i * 70}ms` }}
              >
                {/* Background image */}
                <img
                  src={b.image}
                  alt={b.title}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-110"
                />
                {/* Gradient overlay */}
                <div
                  className="absolute inset-0"
                  style={{
                    background:
                      "linear-gradient(180deg, rgba(60,57,80,0.05) 0%, rgba(60,57,80,0.55) 55%, rgba(60,57,80,0.92) 100%)",
                  }}
                />
                {/* Brand accent on hover */}
                <div
                  className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500"
                  style={{
                    background:
                      "linear-gradient(180deg, rgba(71,118,185,0) 0%, rgba(50,138,87,0.45) 100%)",
                  }}
                />

                {/* Icon top-left */}
                <div
                  className="absolute top-5 left-5 w-12 h-12 rounded-xl flex items-center justify-center backdrop-blur-md border border-white/25 transition-transform duration-500 group-hover:scale-110 group-hover:rotate-3"
                  style={{ background: "rgba(255,255,255,0.12)" }}
                >
                  <Icon className="w-5 h-5 text-white" />
                </div>

                {/* Content bottom */}
                <div className="absolute inset-x-0 bottom-0 p-6 text-white">
                  <h3
                    className="text-xl sm:text-2xl font-bold leading-tight"
                    style={{ fontFamily: "'Bricolage Grotesque', sans-serif" }}
                  >
                    {b.title}
                  </h3>
                  <div
                    className="overflow-hidden transition-all duration-500 ease-out max-h-0 group-hover:max-h-32 opacity-0 group-hover:opacity-100"
                  >
                    <p className="mt-3 text-sm text-white/90 leading-relaxed">{b.text}</p>
                  </div>
                  <div
                    className="mt-3 h-[3px] w-12 rounded-full transition-all duration-500 group-hover:w-24"
                    style={{ background: "linear-gradient(90deg, #4776b9, #328a57)" }}
                  />
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
